import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface CompanyConfiguration {
  companyId: number;
  leftTurnPenaltySeconds: number | null;
}

@Component({
  selector: 'app-company-configuration',
  template: `
    <div class="workspace-page">
      <div class="workspace-page__panel workspace-page__panel--card">
      <header class="workspace-page__heading">
        <h1 class="workspace-page__title">Company Configuration</h1>
      </header>
      <div *ngIf="loading" class="loading">Loading…</div>
      <div *ngIf="error"   class="error">{{ error }}</div>
      <div *ngIf="saved"   class="success">Configuration saved.</div>

      <form *ngIf="settings && !loading" (ngSubmit)="save()" #f="ngForm">
        <fieldset>
          <legend>Routing</legend>
          <label>Left-Turn Penalty (seconds)
            <input type="number" min="0" [(ngModel)]="settings.leftTurnPenaltySeconds"
                   name="leftTurnPenaltySeconds" placeholder="0 = disabled" />
          </label>
        </fieldset>

        <div class="form-actions">
          <button class="br-btn br-btn--primary" type="submit" [disabled]="saving">
            {{ saving ? 'Saving…' : 'Save' }}
          </button>
        </div>
      </form>
      </div>
    </div>
  `,
})
export class CompanyConfigurationComponent implements OnInit {
  settings: CompanyConfiguration | null = null;
  loading = true;
  saving  = false;
  saved   = false;
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<CompanyConfiguration>('/api/account-settings').subscribe({
      next:  s  => { this.settings = s; this.loading = false; },
      error: () => { this.error = 'Failed to load configuration.'; this.loading = false; },
    });
  }

  save(): void {
    if (!this.settings) return;
    this.saving = true;
    this.saved  = false;
    this.error  = null;
    this.http.put('/api/account-settings', this.settings).subscribe({
      next:  () => { this.saving = false; this.saved = true; },
      error: () => { this.saving = false; this.error = 'Save failed.'; },
    });
  }
}
